import React from 'react';

const Tick = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 16 12"
			className={className}
		>
			<path
				fill="#5999D5"
				d="M5.887 11.23c-.315 0-.63-.12-.87-.36L1.248 7.098a1.232 1.232 0 0 1 1.74-1.74l2.9 2.899 7.13-7.13a1.232 1.232 0 0 1 1.74 1.74l-8 8c-.24.24-.558.36-.874.36l.003.003Z"
			/>
		</svg>
	);
};

export default Tick;
